import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('format_schedule_time', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})
Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  else return `${date} ${month} ${year}`
})
Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('first_letter_uppercase', function (val) {
  if (val) {
    const str = val.toLowerCase().replace(/\b[a-z]/g, function (letter) {
      return letter.toUpperCase()
    })
    return str
  }
  return val

})
 
Vue.filter('weekday_abbr', function (val) {
  return val.substring(0, 3).toUpperCase()
})
// Vue.filter('amountFix', function (val) {
//   const amount =   parseFloat(val).toFixed(2)
//   return amount < 0 ?   `-$${Math.abs(amount)}` :   `$${amount}`
 

// })
Vue.filter('amountFix', function (val) {
  
  if (val === null || typeof val === 'undefined') return '$0.00'
 
  const amount =  parseFloat(val.toString().replace(/,/g, ''))
  const formattedAmount = Number(amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
  return formattedAmount
   
})